import { render } from "./skeletonWrapper.vue?vue&type=template&id=748d4a34"
import script from "./skeletonWrapper.vue?vue&type=script&lang=js"
export * from "./skeletonWrapper.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./skeletonWrapper.vue?vue&type=style&index=0&id=748d4a34&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__